import { render } from "./RevueCulture.vue?vue&type=template&id=04cb44ba&scoped=true&ts=true"
import script from "./RevueCulture.vue?vue&type=script&lang=ts"
export * from "./RevueCulture.vue?vue&type=script&lang=ts"

import "./RevueCulture.vue?vue&type=style&index=0&id=04cb44ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cb44ba"]])

export default __exports__